import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  TWO_FACTOR_REQUIRED,
  TWO_FACTOR_CANCEL,
  TWO_FACTOR_VERIFY,
  TWO_FACTOR_VERIFY_SUCCESS,
  TWO_FACTOR_VERIFY_ERROR,
  TWO_FACTOR_RESEND,
  TWO_FACTOR_RESEND_SUCCESS,
  TWO_FACTOR_RESEND_ERROR,
  ENTRAID_CALLBACK,
  ENTRAID_AUTHORIZATION_ERROR,
} from './actionTypes';

export const loginUser = (email, password) => {
  return {
    type: LOGIN_USER,
    payload: { email, password },
  };
};

export const loginSuccess = () => {
  return {
    type: LOGIN_SUCCESS,
  };
};

export const logoutUser = () => {
  return {
    type: LOGOUT_USER,
  };
};

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
  };
};

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const twoFactorRequired = data => ({
  type: TWO_FACTOR_REQUIRED,
  payload: data,
});

export const twoFactorCancel = () => ({
  type: TWO_FACTOR_CANCEL,
});

export const twoFactorVerify = code => ({
  type: TWO_FACTOR_VERIFY,
  payload: { code },
});

export const twoFactorVerifySuccess = () => ({
  type: TWO_FACTOR_VERIFY_SUCCESS,
});

export const twoFactorVerifyError = error => ({
  type: TWO_FACTOR_VERIFY_ERROR,
  payload: error,
});

export const twoFactorResend = () => ({
  type: TWO_FACTOR_RESEND,
});

export const twoFactorResendSuccess = () => ({
  type: TWO_FACTOR_RESEND_SUCCESS,
});

export const twoFactorResendError = error => ({
  type: TWO_FACTOR_RESEND_ERROR,
  payload: error,
});

export const entraIdCallback = (code, state) => ({
  type: ENTRAID_CALLBACK,
  payload: { code, state },
});

export const entraIdAuthorizationError = (state, error, errorDescription) => ({
  type: ENTRAID_AUTHORIZATION_ERROR,
  payload: { state, error, errorDescription },
});
